import { type AnnouncementPlacement, type AnnouncementStyle, type AnnouncementTone } from '../constants';

type ResolveAnnouncementToneParams = {
  placement: AnnouncementPlacement | undefined;
  style: AnnouncementStyle;
};

/** Placement tone wins, then `style.tone`, then `neutral`. */
export const resolveAnnouncementTone = ({ placement, style }: ResolveAnnouncementToneParams): AnnouncementTone => {
  return placement?.tone ?? style.tone ?? 'neutral';
};
